'use strict';

exports.__esModule = true;
exports.SpecialtySvgIcon = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svgIcon = require('../../../svg-icon');

var _constants = require('../utils/constants');

var _utils = require('../utils/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpecialtySvgIcon = exports.SpecialtySvgIcon = function SpecialtySvgIcon(_ref) {
    var className = _ref.className,
        specialtyIconUri = _ref.specialtyIconUri;

    var icon = (0, _utils.transformSpecialtyIconUri)(specialtyIconUri, _constants.MISSING_ICONS_DICTIONARY);

    return _react2.default.createElement(_svgIcon.SvgIcon, { className: className, icon: icon });
};

SpecialtySvgIcon.displayName = 'SpecialtySvgIcon';

SpecialtySvgIcon.defaultProps = {
    className: '',
    specialtyIconUri: ''
};


// WEBPACK FOOTER //
// ./components/specialty-svg-icon/lib/components/specialty-svg-icon.js